<template>
    <div v-if="lang" class="search-bar mx-auto">
        <div v-if="showContractButtons" class="contract-buttons">
            <a
                v-if="config.tab.sale"
                class="btn"
                :class="{ active: btn_active === 'acquis' }"
                @click="setContract('acquis')"
            >
                {{ lang.labels.acquis }}
            </a>

            <a
                v-if="config.tab.rent"
                class="btn"
                :class="{ active: btn_active === 'locazi' }"
                @click="setContract('locazi')"
            >
                {{ lang.labels.locazi }}
            </a>

            <a
                v-if="config.tab.evaluation"
                class="btn"
                :class="{ active: btn_active === 'evaluation' }"
                @click="setEvaluationMode()"
            >
                {{ lang.labels.evaluation }}
            </a>

            <a
                v-if="config.tab.sell_estate"
                class="btn"
                :class="{ active: btn_active === 'sell_estate' }"
                @click="setSellEstateMode()"
            >
                {{ lang.labels.sell_estate }}
            </a>

            <a
                v-if="config.tab.industrial"
                class="btn"
                :class="{ active: btn_active === 'industrial' }"
                :href="('annunci+commerciali.html')"
            >
                {{ lang.labels.industrial }}
            </a>

            <a
                v-if="config.tab.ref"
                class="btn"
                :class="{ active: btn_active === 'ref' }"
                @click="setRef()"
            >
                {{ lang.labels.ref }}
            </a>
            
        </div>

        <form
            class="search-bar-form"
            :class="{ 'is-fullscreen': full_screen }"
            ref="form"
            method="get"
            :action="current_action" 
            @submit.prevent="onSubmit"
            autocomplete="off"
        >
            <div v-if="full_screen" class="full-screen-header">
                {{ lang.labels.choose_place }}
                <button class="btn" @click="closeFullScreen">
                   <masked-image src="/img/icons/close.svg" height="20" width="20"></masked-image>
                </button>
            </div>

            <base-estates-fields
                v-if="mode == 'form'"
                :contract="form.contract"
                :districts="form.districts"
                :quarters="form.quarters"
                :geo="geo"
                :id="form.id"
                :results_type="form.results_type"
                :sector="form.sector"
            />

            <div v-if="sector_select" class="sector-dropdown" id="sector-dropdown">
                <div class="sector-dropdown-value" @click="toggleDropdown">
                    <img alt="'+ current_sector +'" :src="'/img/icons/sector/' + current_sector + '.svg'" height="22" width="26" />
                    <img :src="'/img/icons/angle-' + angleDirection + '.svg'" :alt="lang.labels.sector_dropdown" height="6" width="9">
                </div>

                <ul v-show="sector_links_is_open" class="sector-dropdown-options">
                    <slot name="sector-links" :current-sector="current_sector" :set-sector="setSector"></slot>
                </ul>
            </div>

            <geo-autocomplete
                v-if="search_type === 'estates' && config.mode == 'autocomplete'"
                :is-home="true"
                :contract="form.contract"
                :section="current_section"
                :sector="form.sector"
                :config="config"
                :config_map="config_map"
                @focus="openFullScreen"
                @input="search"
                @show-districts="showDistricts"
            />

            <geo-select
                v-else-if="search_type === 'estates' && config.mode == 'select'"
                :is-home="true"
                :contract="form.contract"
                :section="current_section"
                :sector="form.sector"
                :config="config"
                @input="search"
            ></geo-select>

            <geo-autocomplete
                v-else-if="search_type === 'ref'"
                :is-home="true"
                :contract="form.contract"
                :section="current_section"
                :sector="form.sector"
                :config="config"
                :config_map="config_map"
                @input="search"
            />

            <address-autocomplete
                v-else
                :exclude="['country', 'state', 'district']"
                @focus="openFullScreen"
                @input="searchAddress"
            />

            <districts-list
                v-if="city && show_districts"
                v-model="form.districts"
                :is_home="is_home"
                :city="city"
                :config="config"
                :config_map="config_map"
                :contract="form.contract"
                :section="current_section"
                :sector="form.sector"
                @hide-districts="hideDistricts"
            />

            <div class="search-icon">
                <img :src="'/img/icons/' + $root.network + '/search.svg'" alt="Cerca" height="25" width="23">
            </div>
        </form>
    </div>
</template>

<script>
import AddressAutocomplete from './AddressAutocomplete'
import BaseEstatesFields from './estates/BaseFields'
import DistrictsList from './DistrictsList'
import GeoAutocomplete from './GeoAutocomplete'
import GeoSelect from './GeoSelect'

export default {
    components: {
        'address-autocomplete': AddressAutocomplete,
        'base-estates-fields': BaseEstatesFields,
        'districts-list': DistrictsList,
        'geo-autocomplete': GeoAutocomplete,
        'geo-select': GeoSelect,
    },

    props: {
        action: {
            type: [String,Boolean],
            required: true,
        },

        config: {
            type: Object,
            required: true,
        },

        config_map: {
            type: Object,
            required: true,
        },

        is_home: {
            type: Boolean,
            required: false,
        },

        sector: {
            type: String,
            default: 'res',
        },

        section: {
            type: String,
            default: 'res',
        },
        
        showContractButtons: {
            type: Boolean,
            default: true,
        },

        type: {
            type: String,
            default: 'estates',
        },

        mode: {
            type: String,
            default: 'form',
        },        
    },

    data() {
        return {
            body_classes: {
                can: 'constructions',
                ind: 'industrial',
                res: 'residential',
                tur: 'touristic',
            },
            city: null,
            form: {
                contract: 'acquis',
                districts: '',
                quarters: '',
                sector: this.sector,
                results_type: '',
                id: 0
            },
            geo: null,
            current_sector: this.sector,
            current_section: this.section,
            current_action: this.action,
            full_screen: false,
            search_type: this.type,
            sector_select: this.config.section ? true : false,
            sector_links_is_open: false,
            show_districts: false,
            btn_active: 'acquis'
        }
    },

    computed: {
        angleDirection() {
            return this.sector_links_is_open ? 'up' : 'down'
        },

        lang() {
            return this.$root.lang.search_bar
            return this.$root.lang.routes
        },
    },

    mounted() {
        this.watchClickOutsideSectorDropdown()

        window.events.$on('search_by_city', city => {
            this.form.districts = ''

            if( this.mode == 'form' ){
                this.$nextTick(() => {
                    this.$refs.form.submit()
                })
            }
        })

        window.events.$on('search_by_districts', districts => {
            this.form.districts = districts.id
            this.form.quarters = districts.quarters_id
            this.form.city = districts.city_id
            this.form.province = districts.province_id
            this.form.results_type = 'estates'

            window.events.$emit('update_basefields', {form: this.form})

            if( this.mode == 'form' ){
                this.$nextTick(() => {
                    this.$refs.form.submit()
                })
            }
        })

        window.events.$on('agencySearch', () => {
            this.closeFullScreen()
        })

        window.events.$on('sector.searchbar.update', (sector) => {
            this.current_sector = this.form.sector = sector

            document.body.classList.add('home-' + this.body_classes[sector])
        })
    },

    methods: {
        closeFullScreen() {
            this.full_screen = false
        },

        onSubmit(e) {
            e.preventDefault();
        },

        search(result) {
            this.geo = JSON.stringify(result)

            this.form.results_type = result.results_type
            this.form.id = result.id
            this.form.districts = ''

            if(this.mode == 'form' && ! result.show_districts) {
                this.$nextTick(() => {
                    this.$refs.form.submit()
                })
            }

            if( this.mode == 'event'){
                this.$emit('input', { geo: result, sector: this.current_sector})
            }
        },

        searchAddress(result) {
            if ((!result.place_name) || (!result.position)) {
                return
            }
            if (this.section == 'estate') {
                let url = ''
                if (this.search_type == 'evaluation') {
                    url = this.lang.href.evaluation
                } else if (this.search_type == 'sell_estate') {
                    url = this.lang.href.sell_estate
                } else {
                    return
                }
                
                location.href = url + '?address=' + result.place_name + '&latitude=' + result.position.latitude + '&longitude=' + result.position.longitude
                
            } else if (this.section == 'agency') {
                this.$emit('input', { geo: result, sector: this.current_sector})
            }
        },

        setContract(contract) {
            this.form.contract = contract
            this.search_type = 'estates'
            this.btn_active = contract
            if (this.config.section) {
                this.sector_select = true
            }
        },

        setEvaluationMode() {
            this.form.contract = null
            this.search_type = 'evaluation'
            this.btn_active = 'evaluation'
            this.sector_select = false
        },

        setSellEstateMode() {
            this.form.contract = null
            this.search_type = 'sell_estate'
            this.btn_active = 'sell_estate'
            this.sector_select = false
        },

        setRef() {
            this.form.contract = null
            this.search_type = 'ref'
            this.btn_active = 'ref'
            this.sector_select = false
        },

        openFullScreen() {
            if(this.$root.is_mobile) {
                this.full_screen = true
            }
        },

        setSector(sector, section, action) {
            this.current_sector = this.form.sector = sector
            this.current_section = this.form.section = section
            this.current_action = this.form.action = action

            document.body.classList.remove('home-residential')
            document.body.classList.remove('home-industrial')
            document.body.classList.remove('home-constructions')
            document.body.classList.remove('home-touristic')

            if (document.getElementById('home-claim-bold')) {
                document.getElementById('home-claim-bold').textContent = this.lang.claim.bold[sector]
            }

            if (document.getElementById('home-claim-light')) {
                document.getElementById('home-claim-light').textContent = this.lang.claim.light[sector]
            }

            document.body.classList.add('home-' + this.body_classes[sector])

            this.toggleDropdown()
        },

        showDistricts(city) {
            this.city = city
            this.show_districts = true
        },

        hideDistricts() {
            this.show_districts = false
        },

        toggleDropdown() {
            this.sector_links_is_open = ! this.sector_links_is_open
        },

        watchClickOutsideSectorDropdown() {
            window.addEventListener('click', e => {
                if(this.sector_links_is_open) {
                    let container = document.getElementById('sector-dropdown')

                    if (! container.contains(e.target)) {
                        this.sector_links_is_open = false
                    }   
                }
            })
        },
    },
}
</script>
